// extracted by mini-css-extract-plugin
export default {"cafe_setting":"editCafeInfo_cafe_setting__GQ34a","cafe_setting_label":"editCafeInfo_cafe_setting_label__IcQvK"};